import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { StoreModule } from '@ngrx/store';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import {
    ChartsExpensesByCategoryComponent,
} from 'app/main/charts/charts-expenses-by-category/charts-expenses-by-category.component';
import { ChartsExpensesComponent } from 'app/main/charts/charts-expenses/charts-expenses.component';
import {
    ChartsRevenueByCategoryComponent,
} from 'app/main/charts/charts-revenue-by-category/charts-revenue-by-category.component';
import { ChartsRevenueComponent } from 'app/main/charts/charts-revenue/charts-revenue.component';
import { ChartsComponent } from 'app/main/charts/charts.component';
import * as fromCharts from 'app/main/charts/charts.reducer';
import { ChartsResolver } from 'app/main/charts/charts.resolver';
import { MaterialModule } from 'app/main/material.module';

import { CubeModule } from '../cube/cube.module';

@NgModule({
    declarations: [
        ChartsComponent,
        ChartsExpensesComponent,
        ChartsRevenueComponent,
        ChartsRevenueByCategoryComponent,
        ChartsExpensesByCategoryComponent,
    ],
    imports     : [
        FuseSharedModule,
        MaterialModule,
        PageTitleModule,
        RouterModule,
        NgxChartsModule,
        CubeModule,
        StoreModule.forFeature('charts', fromCharts.chartsReducer),

    ],
    exports     : [
        ChartsComponent
    ],
    providers: [
        ChartsResolver
    ]
})

export class ChartsModule
{
}
